export default __webpack_public_path__ + "static/media/removed.140e100e.svg";